<template>
  <smd-one-col-layout class="modal-terms-and-conditions">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="closeModal"/>

      <h2 class="Title3 gray-400">
        Terms & Conditions
      </h2>

      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dignissim pulvinar ligula, eu hendrerit tortor
      maximus nec. Duis quis massa nec est imperdiet posuere sed id quam. Praesent nec iaculis felis. Proin eget libero
      arcu. Quisque ex orci, dictum pretium lorem nec, commodo rutrum nulla. Integer feugiat velit vitae leo posuere
      accumsan. Praesent sollicitudin dignissim pulvinar. Cras urna augue, convallis id lectus vel, varius semper
      ligula. Sed faucibus commodo massa, condimentum dictum orci vestibulum quis. Duis ut ultricies sapien. Praesent
      lacinia urna non mauris pharetra, mollis vulputate justo dictum. Lorem ipsum dolor sit amet, consectetur
      adipiscing elit. Phasellus aliquet metus nec diam sollicitudin, nec condimentum tortor tempus. Mauris tempus ac
      metus et bibendum. Sed varius iaculis arcu non tristique. Cras semper eget augue in lobortis.

      Nunc porttitor risus blandit, bibendum nibh non, bibendum ligula. Pellentesque ultrices orci sit amet leo semper
      pellentesque vitae at enim. Fusce pellentesque elit at tristique rutrum. Nulla sit amet pharetra ligula, ac
      pellentesque est. Nulla tincidunt sit amet diam id consectetur. Aliquam id scelerisque est. Pellentesque porta
      ligula quis semper consectetur. Quisque rhoncus fermentum lacus non viverra. Quisque aliquet eleifend libero, ut
      mollis dolor accumsan eget. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
      Etiam lacinia, quam nec luctus convallis, erat libero consectetur risus, id posuere ligula magna eget lorem. Proin
      condimentum, urna luctus ornare vehicula, mauris erat condimentum massa, vitae egestas nisi ante ac mauris.
      Quisque pharetra dui at ultrices laoreet. Curabitur mi ligula, congue in massa eget, molestie convallis felis.</p>

    <!--    <div class="smd-form__row flex-col list">-->
    <!--      <p v-for="(term, index) in $options.termsList"-->
    <!--         :key="index"-->
    <!--         class="Paragraph1">-->
    <!--        {{ index + 1 }}. {{ term }}-->
    <!--      </p>-->
    <!--    </div>-->

    <!--    <div class="smd-form__row">-->
    <!--      <p class="Paragraph1">Always consult your doctor if you have any questions or concerns on the prescribed-->
    <!--        medicines and the samples you received.</p>-->
    <!--    </div>-->

    <!--    <div class="smd-checkbox__row">-->
    <!--      <smd-checkbox v-model="termsAgreed"-->
    <!--                    label="I agree to NowServing forwarding my ePrescription and the sample redemption code to the Pharmacy of my choice, together with my other information like name and contact details, so that the receiving pharmacy may validate my purchase and serve me properly."/>-->
    <!--    </div>-->

    <!--    <div class="smd-form__row justify-content-center">-->
    <!--      <a class="Hyperlink2" href="https://static.seriousmd.com/programs/sanofi_tryit_tc_viber.html"-->
    <!--         target="_blank">-->
    <!--        Full Terms & Conditions-->
    <!--      </a>-->
    <!--    </div>-->
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import {mapFields} from 'vuex-map-fields';

  export default {
    name: "modal-terms-and-conditions",
    mixins: [CloseModalMixin],
    computed: {
      ...mapFields({
        termsAgreed: 'termsAgreed',
      }),
    },
    termsList: [
      'The unique redemption codes will only be generated once and can only be redeemed once.',
      'Unique Sample redemption codes must be supported by an ePrescription that will be given to the patients.',
      'Sample redemption codes are not transferable, cannot be converted to cash and have no cash equivalent.',
      'There will be assigned Pharmacy/branch redemption centers based on the patient’s preference.',
      'Terms and conditions of the delivery will depend on the redemption pharmacy partner T&C.',
    ],
  }
</script>

<style lang="scss">
  @import '~@/assets/styles/util';

  .modal-terms-and-conditions {
    .list {
      p:not(:last-child) {
        margin-bottom: space(xs);
      }
    }

    .smd-checkbox {
      align-items: flex-start;
    }
  }
</style>